import { createSlice } from '@reduxjs/toolkit';
import { checkin, getCheckinPercentage, getPersonal } from './dashboardActions';

const initialState = {
  loading: false,
  checkinLoading: false,
  checkinPercent: null,
  personal: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers: {
    [getCheckinPercentage.pending]: state => {
      state.checkinLoading = true;
    },
    [getCheckinPercentage.fulfilled]: (state, { payload }) => {
      state.checkinLoading = false;
      state.checkinPercent = payload.data;
    },
    [getCheckinPercentage.rejected]: (state, { payload }) => {
      state.checkinLoading = false;
      state.error = payload;
    },
    [getPersonal.pending]: state => {
      state.loading = true;
    },
    [getPersonal.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.personal = payload.data;
    },
    [getPersonal.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    [checkin.pending]: state => {
      state.checkinLoading = true;
    },
    [checkin.fulfilled]: (state, { payload }) => {
      state.checkinLoading = false;
      // state.checkinPercent = payload.data;
    },
    [checkin.rejected]: (state, { payload }) => {
      state.checkinLoading = false;
      state.error = payload;
    },
  },
});
export default dashboardSlice.reducer;
